





























import Vue from 'vue'
import { Currency } from '@/Domain/Batch/Currency'
import SpeciesFormattedNumberInput from '@/UI/AuctionB/Declarations/OfferTable/SpeciesFormattedNumberInput.vue'
import SimpleInput from '@/UI/Shared/SimpleInput.vue'

export default Vue.extend({
  name: 'SpeciesTargetRow',
  components: { SpeciesFormattedNumberInput, SimpleInput },
  props: {
    binomen: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    volume: {
      type: String,
      required: true
    },
    showGeneralData: {
      type: Boolean,
      default: false
    },
    targetCost: {
      type: String,
      required: true
    },
    targetVolume: {
      type: String,
      required: true
    },
    identifier: {
      type: String,
      required: true
    },
    innerLabel: {
      type: String,
      required: true
    },
    inputPrice: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentInputPrice: '',
      inputIsValid: false
    }
  },
  computed: {
    totalPrice (): string {
      if (this.inputIsValid === false) {
        return ''
      }
      const currency = Currency.fromString(this.currentInputPrice)
        .multiply(Currency.fromString(this.targetVolume))
      return currency.toString()
    }
  },
  watch: {
    inputPrice (newValue: string) {
      this.currentInputPrice = newValue
    }
  },
  created () {
    this.currentInputPrice = this.inputPrice
  },
  methods: {
    onPriceUpdated ($event: string) {
      this.$emit('target-price-updated', {
        label: this.innerLabel,
        price: $event,
        totalPrice: this.inputIsValid ? this.totalPrice : '',
        isValid: this.inputIsValid
      })
    }
  }
})
